exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub_t[data-v-c8d9c75e]{font-size:.18rem;font-weight:bold}.page-btns[data-v-c8d9c75e]{margin-top:.4rem;text-align:center}", ""]);

// exports
